var map = {
	"./App": 33184,
	"./App.vue": 33184,
	"./assets/icons/Arrow.svg": 1985,
	"./assets/icons/arrow2.svg": 31273,
	"./assets/icons/barcode-info.svg": 18561,
	"./assets/icons/barcode-search.svg": 67189,
	"./assets/icons/cloud_upload.svg": 56370,
	"./assets/icons/delete.svg": 82539,
	"./assets/icons/error.svg": 39687,
	"./assets/icons/flags/at.svg": 83274,
	"./assets/icons/flags/ch.svg": 54019,
	"./assets/icons/flags/de.svg": 81963,
	"./assets/icons/flags/fr.svg": 75744,
	"./assets/icons/flags/pl.svg": 77982,
	"./assets/icons/form/add.svg": 92061,
	"./assets/icons/form/ar-camera.svg": 4842,
	"./assets/icons/form/checkBoxTick.svg": 16545,
	"./assets/icons/form/checked_checkbox.svg": 20038,
	"./assets/icons/form/down-arrow.svg": 45349,
	"./assets/icons/form/dropdown.svg": 97606,
	"./assets/icons/form/error.svg": 34148,
	"./assets/icons/form/information.svg": 75941,
	"./assets/icons/form/pic.svg": 51168,
	"./assets/icons/form/receipt.svg": 83956,
	"./assets/icons/form/unchecked_checkbox.svg": 20776,
	"./assets/icons/form/video-camera.svg": 99377,
	"./assets/icons/minus.svg": 4475,
	"./assets/icons/pencil.svg": 61265,
	"./assets/icons/placeholder.svg": 22672,
	"./assets/icons/plus.svg": 23189,
	"./assets/icons/risk-icon.svg": 68837,
	"./assets/icons/search-icon.svg": 94609,
	"./assets/icons/step.svg": 8690,
	"./assets/icons/success.svg": 54398,
	"./assets/icons/tick.svg": 92058,
	"./assets/images/banner/banner-desktop-old.jpg": 15787,
	"./assets/images/banner/banner-mobile-old.jpg": 54088,
	"./assets/images/banner/gratis/banner-desktop.jpg": 5402,
	"./assets/images/banner/gratis/banner-mobile.jpg": 91589,
	"./assets/images/banner/unstoppables/banner-desktop.jpg": 49424,
	"./assets/images/banner/unstoppables/banner-mobile.jpg": 34249,
	"./assets/images/png/barcode.png": 39102,
	"./assets/images/png/barcodeWrite.png": 88905,
	"./assets/images/png/cash.png": 57657,
	"./assets/images/png/check_1.png": 45442,
	"./assets/images/png/check_1_1.png": 6290,
	"./assets/images/png/check_1_2.png": 71811,
	"./assets/images/png/check_1_3.png": 97585,
	"./assets/images/png/check_1_4.png": 52726,
	"./assets/images/png/check_2.png": 90145,
	"./assets/images/png/check_2_2.png": 20857,
	"./assets/images/png/check_3.png": 31108,
	"./assets/images/png/check_3_2.png": 83470,
	"./assets/images/png/check_4.png": 499,
	"./assets/images/png/check_4_2.png": 39517,
	"./assets/images/png/error.png": 1652,
	"./assets/images/png/footer-image.png": 35425,
	"./assets/images/png/js-logo.png": 75586,
	"./assets/images/png/logo.png": 54656,
	"./assets/images/png/maintenance.png": 62643,
	"./assets/images/png/over.png": 81624,
	"./assets/images/png/product-1.png": 86275,
	"./assets/images/png/product-2.png": 81857,
	"./assets/images/png/product.png": 1256,
	"./assets/images/png/products.png": 84976,
	"./assets/images/png/receipt-old.png": 20145,
	"./assets/images/png/receipt.png": 6353,
	"./assets/images/png/thanks.png": 23723,
	"./assets/images/steps/arrow-mobile.png": 81880,
	"./assets/images/steps/arrow.png": 88119,
	"./assets/images/steps/step-1.png": 80853,
	"./assets/images/steps/step-2.png": 38637,
	"./assets/images/steps/step-3.png": 58224,
	"./assets/images/steps/step-4.png": 49441,
	"./assets/images/svg/checkMark.svg": 92489,
	"./assets/images/svg/check_1.svg": 75158,
	"./assets/images/svg/check_2.svg": 82013,
	"./assets/images/svg/check_3.svg": 63806,
	"./assets/images/svg/check_4.svg": 86562,
	"./assets/images/svg/clipboard.svg": 11432,
	"./assets/images/svg/cross_red.svg": 79136,
	"./assets/images/svg/done.svg": 6486,
	"./assets/images/svg/down-arrow.svg": 66016,
	"./assets/images/svg/dropdown.svg": 22952,
	"./assets/images/svg/everydayLogo.svg": 92420,
	"./assets/images/svg/expired.svg": 90969,
	"./assets/images/svg/lock.svg": 58619,
	"./assets/images/svg/navbar-toggler.svg": 48989,
	"./assets/images/svg/paper.svg": 31099,
	"./assets/images/svg/pglogo.svg": 90191,
	"./assets/images/svg/receipt-cs.svg": 21626,
	"./assets/images/svg/receipt-pl.svg": 28636,
	"./assets/images/svg/upload.svg": 81528,
	"./assets/logo.png": 66949,
	"./assets/receipt_image.png": 25299,
	"./assets/styles/_application.scss": 64706,
	"./assets/styles/receipt-editor.css": 55684,
	"./assets/styles/resp-table.css": 85244,
	"./auth": 94192,
	"./auth/": 94192,
	"./auth/authWrapper": 99582,
	"./auth/authWrapper.js": 99582,
	"./auth/index": 94192,
	"./auth/index.js": 94192,
	"./components/component-renderer": 77130,
	"./components/component-renderer.vue": 77130,
	"./components/loading": 96101,
	"./components/loading.vue": 96101,
	"./components/modal": 41645,
	"./components/modal.vue": 41645,
	"./components/page": 5180,
	"./components/page.vue": 5180,
	"./components/receipt-editor": 76394,
	"./components/receipt-editor/": 76394,
	"./components/receipt-editor/Cropper": 89981,
	"./components/receipt-editor/Cropper.vue": 89981,
	"./components/receipt-editor/Erazer": 33910,
	"./components/receipt-editor/Erazer.vue": 33910,
	"./components/receipt-editor/FileInput": 55722,
	"./components/receipt-editor/FileInput.vue": 55722,
	"./components/receipt-editor/ImageDrawer": 96136,
	"./components/receipt-editor/ImageDrawer.vue": 96136,
	"./components/receipt-editor/ReceiptScanLoader": 48859,
	"./components/receipt-editor/ReceiptScanLoader.vue": 48859,
	"./components/receipt-editor/ReceiptScanner": 38822,
	"./components/receipt-editor/ReceiptScanner.vue": 38822,
	"./components/receipt-editor/Zoomer": 69105,
	"./components/receipt-editor/Zoomer.vue": 69105,
	"./components/receipt-editor/index": 76394,
	"./components/receipt-editor/index.js": 76394,
	"./components/renderers": 15148,
	"./components/renderers/": 15148,
	"./components/renderers/BarcodeScanner": 83910,
	"./components/renderers/BarcodeScanner/": 83910,
	"./components/renderers/BarcodeScanner/BarcodeScanner": 14563,
	"./components/renderers/BarcodeScanner/BarcodeScanner.vue": 14563,
	"./components/renderers/BarcodeScanner/SearchModule": 50798,
	"./components/renderers/BarcodeScanner/SearchModule.vue": 50798,
	"./components/renderers/BarcodeScanner/TabButtons": 86484,
	"./components/renderers/BarcodeScanner/TabButtons.vue": 86484,
	"./components/renderers/BarcodeScanner/index": 83910,
	"./components/renderers/BarcodeScanner/index.vue": 83910,
	"./components/renderers/BarcodeScanner/promise-timeout": 45573,
	"./components/renderers/BarcodeScanner/promise-timeout.js": 45573,
	"./components/renderers/FormWizard": 99502,
	"./components/renderers/FormWizard/": 99502,
	"./components/renderers/FormWizard/components/FormWizard": 59290,
	"./components/renderers/FormWizard/components/FormWizard.vue": 59290,
	"./components/renderers/FormWizard/components/TabContent": 34957,
	"./components/renderers/FormWizard/components/TabContent.vue": 34957,
	"./components/renderers/FormWizard/components/WizardButton": 44669,
	"./components/renderers/FormWizard/components/WizardButton.vue": 44669,
	"./components/renderers/FormWizard/components/WizardStep": 76650,
	"./components/renderers/FormWizard/components/WizardStep.vue": 76650,
	"./components/renderers/FormWizard/components/helpers": 38491,
	"./components/renderers/FormWizard/components/helpers.js": 38491,
	"./components/renderers/FormWizard/index": 99502,
	"./components/renderers/FormWizard/index.js": 99502,
	"./components/renderers/ProductList": 27559,
	"./components/renderers/ProductList.vue": 27559,
	"./components/renderers/ProductSelection": 80417,
	"./components/renderers/ProductSelection/": 80417,
	"./components/renderers/ProductSelection/index": 80417,
	"./components/renderers/ProductSelection/index.vue": 80417,
	"./components/renderers/ProductSelection/product": 80840,
	"./components/renderers/ProductSelection/product.vue": 80840,
	"./components/renderers/SmsVerification/sms-receiving": 6569,
	"./components/renderers/SmsVerification/sms-receiving.vue": 6569,
	"./components/renderers/SmsVerification/sms-verification": 85349,
	"./components/renderers/SmsVerification/sms-verification.vue": 85349,
	"./components/renderers/anchor": 59643,
	"./components/renderers/anchor.vue": 59643,
	"./components/renderers/barcode-information": 53048,
	"./components/renderers/barcode-information.vue": 53048,
	"./components/renderers/button-component": 46657,
	"./components/renderers/button-component.vue": 46657,
	"./components/renderers/campaign-disclaimer": 23403,
	"./components/renderers/campaign-disclaimer.vue": 23403,
	"./components/renderers/campaign-grid": 57229,
	"./components/renderers/campaign-grid.vue": 57229,
	"./components/renderers/checkReceiptToken": 30289,
	"./components/renderers/checkReceiptToken.vue": 30289,
	"./components/renderers/checkbox": 64420,
	"./components/renderers/checkbox.vue": 64420,
	"./components/renderers/clipboard": 87523,
	"./components/renderers/clipboard.vue": 87523,
	"./components/renderers/datalayer-event": 99563,
	"./components/renderers/datalayer-event.vue": 99563,
	"./components/renderers/date-input": 24140,
	"./components/renderers/date-input.vue": 24140,
	"./components/renderers/docs-embed": 66883,
	"./components/renderers/docs-embed.vue": 66883,
	"./components/renderers/doi": 1341,
	"./components/renderers/doi.vue": 1341,
	"./components/renderers/empty-bucket": 91257,
	"./components/renderers/empty-bucket.vue": 91257,
	"./components/renderers/faq": 22553,
	"./components/renderers/faq.vue": 22553,
	"./components/renderers/file-uploader": 36741,
	"./components/renderers/file-uploader.vue": 36741,
	"./components/renderers/footer-component": 6933,
	"./components/renderers/footer-component.vue": 6933,
	"./components/renderers/form-component": 94850,
	"./components/renderers/form-component.vue": 94850,
	"./components/renderers/gtin-component": 88257,
	"./components/renderers/gtin-component.vue": 88257,
	"./components/renderers/iban-reupload": 51481,
	"./components/renderers/iban-reupload.vue": 51481,
	"./components/renderers/index": 15148,
	"./components/renderers/index.js": 15148,
	"./components/renderers/key-visual": 7798,
	"./components/renderers/key-visual.vue": 7798,
	"./components/renderers/navbar": 74622,
	"./components/renderers/navbar-new": 84980,
	"./components/renderers/navbar-new.vue": 84980,
	"./components/renderers/navbar.vue": 74622,
	"./components/renderers/paragraph": 58083,
	"./components/renderers/paragraph.vue": 58083,
	"./components/renderers/participation": 73687,
	"./components/renderers/participation.vue": 73687,
	"./components/renderers/pdf-viewer": 65825,
	"./components/renderers/pdf-viewer.vue": 65825,
	"./components/renderers/product-information": 84082,
	"./components/renderers/product-information.vue": 84082,
	"./components/renderers/product-upload": 82350,
	"./components/renderers/product-upload.vue": 82350,
	"./components/renderers/progress-bar": 7567,
	"./components/renderers/progress-bar.vue": 7567,
	"./components/renderers/query-string-to-state": 85100,
	"./components/renderers/query-string-to-state.vue": 85100,
	"./components/renderers/question": 81824,
	"./components/renderers/question.vue": 81824,
	"./components/renderers/radio-input": 54276,
	"./components/renderers/radio-input.vue": 54276,
	"./components/renderers/receipt-examples": 8149,
	"./components/renderers/receipt-examples.vue": 8149,
	"./components/renderers/receipt-information": 11584,
	"./components/renderers/receipt-information-old": 880,
	"./components/renderers/receipt-information-old.vue": 880,
	"./components/renderers/receipt-information.vue": 11584,
	"./components/renderers/receipt-processor": 48849,
	"./components/renderers/receipt-processor.vue": 48849,
	"./components/renderers/reclaim-bucket": 20621,
	"./components/renderers/reclaim-bucket.vue": 20621,
	"./components/renderers/refresh-token": 16827,
	"./components/renderers/refresh-token.vue": 16827,
	"./components/renderers/select-input": 46304,
	"./components/renderers/select-input.vue": 46304,
	"./components/renderers/sign-in-okta": 41479,
	"./components/renderers/sign-in-okta.vue": 41479,
	"./components/renderers/square-image": 66152,
	"./components/renderers/square-image.vue": 66152,
	"./components/renderers/step-card": 73524,
	"./components/renderers/step-card.vue": 73524,
	"./components/renderers/step-counter": 57855,
	"./components/renderers/step-counter.vue": 57855,
	"./components/renderers/steps-horizontal": 5820,
	"./components/renderers/steps-horizontal.vue": 5820,
	"./components/renderers/survey": 11971,
	"./components/renderers/survey.vue": 11971,
	"./components/renderers/terms-component": 13120,
	"./components/renderers/terms-component.vue": 13120,
	"./components/renderers/text-input": 60246,
	"./components/renderers/text-input.vue": 60246,
	"./components/section": 77673,
	"./components/section.vue": 77673,
	"./helpers/common-components": 37366,
	"./helpers/common-components.js": 37366,
	"./i18n": 30354,
	"./i18n/": 30354,
	"./i18n/index": 30354,
	"./i18n/index.js": 30354,
	"./i18n/languages/de": 13895,
	"./i18n/languages/de.js": 13895,
	"./main": 32225,
	"./main.js": 32225,
	"./mixins": 94978,
	"./mixins/": 94978,
	"./mixins/componentActions": 72521,
	"./mixins/componentActions.js": 72521,
	"./mixins/cssVars": 3288,
	"./mixins/cssVars.js": 3288,
	"./mixins/generateUID": 53534,
	"./mixins/generateUID.js": 53534,
	"./mixins/index": 94978,
	"./mixins/index.js": 94978,
	"./mixins/scrollTo": 26125,
	"./mixins/scrollTo.js": 26125,
	"./mixins/showModal": 22822,
	"./mixins/showModal.js": 22822,
	"./mixins/style/_button.mixin.scss": 95362,
	"./mixins/style/_color.scss": 83091,
	"./mixins/updateProperty": 93671,
	"./mixins/updateProperty.js": 93671,
	"./router": 23413,
	"./router/": 23413,
	"./router/index": 23413,
	"./router/index.js": 23413,
	"./store": 4642,
	"./store/": 4642,
	"./store/actions": 78821,
	"./store/actions.js": 78821,
	"./store/ariel": 50773,
	"./store/ariel.js": 50773,
	"./store/campaigns/ariel-old": 60102,
	"./store/campaigns/ariel-old.js": 60102,
	"./store/campaigns/gratis": 37210,
	"./store/campaigns/gratis.js": 37210,
	"./store/campaigns/unstoppables": 48507,
	"./store/campaigns/unstoppables.js": 48507,
	"./store/getters": 90482,
	"./store/getters.js": 90482,
	"./store/index": 4642,
	"./store/index.js": 4642,
	"./store/mutations": 55464,
	"./store/mutations.js": 55464,
	"./vee-validate": 50536,
	"./vee-validate.js": 50536,
	"./views/Home": 78827,
	"./views/Home.vue": 78827,
	"./views/LoginCallback": 58665,
	"./views/LoginCallback.vue": 58665,
	"./views/Maintenance": 64528,
	"./views/Maintenance.vue": 64528
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;